<template>
  <div>
    <div class="row top">
      <div class="row">
        <div class="col-md-2">
          <back-button returnUrl="/vacations"></back-button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <h4><u>Αδράνειες Φορέα</u></h4>
        </div>
      </div>

      <div>
        <DxLoadIndicator
          id="image-indicator"
          :height="40"
          :width="40"
          :visible="loadIndicatorVisible"
        />
      </div>
    </div>

    <div class="grid-pad">
      <DxDataGrid
        :data-source="organizationVacations"
        :allow-column-reordering="true"
        :allow-column-resizing="true"
        :column-auto-width="true"
        :show-borders="true"
        key-expr="Id"
        :show-row-lines="true"
        :row-alternation-enabled="true"
        @init-new-row="onInitNewRow"
        @row-inserting="onRowInserting"
        @row-updating="onRowUpdating"
        @row-removing="onRowRemoving"
        @row-validating="onRowValidating"
      >
        <DxPaging :page-size="20" />
        <DxEditing
          :allow-updating="true"
          :allow-adding="true"
          :allow-deleting="true"
          :use-icons="true"
          mode="cell"
        />
        <DxHeaderFilter :visible="true" />
        <DxFilterRow :visible="true" />
        <DxSearchPanel :visible="true" />
        <DxStateStoring
          :enabled="false"
          type="localStorage"
          storage-key="storage1"
        />

        <!--  <DxColumn  caption="Κωδικός" data-field="Id" data-type="integer" :visible="false">                    
                </DxColumn> -->
        <DxColumn
          caption="Περιγραφή"
          data-field="Description"
          data-type="string"
          :visible="true"
          alignment="left"
        >
          <DxRequiredRule message="Η περιγραφή είναι υποχρεωτική" />
        </DxColumn>
        <DxColumn
          caption="Από"
          data-field="FromDate"
          data-type="date"
          :visible="true"
          alignment="center"
          format="dd/MM/yyyy"
        >
          <DxRequiredRule message="Η Από Ημερομηνία είναι υποχρεωτική" />
        </DxColumn>
        <DxColumn
          caption="Έως"
          data-field="ToDate"
          data-type="date"
          :visible="true"
          alignment="center"
          format="dd/MM/yyyy"
        >
          <DxRequiredRule message="Η Έως Ημερομηνία είναι υποχρεωτική" />
        </DxColumn>
        <DxColumn type="buttons">
          <DxButton name="edit" />
          <DxButton name="delete" />
        </DxColumn>
      </DxDataGrid>
    </div>
  </div>
</template>

<script>
import mainService from "../../services/mainService";
import { DxSelectBox } from "devextreme-vue/select-box";
import {
  DxDataGrid,
  DxColumn,
  DxHeaderFilter,
  DxEditing,
  DxPaging,
  DxFilterRow,
  DxSearchPanel,
  DxButton,
  DxRequiredRule,
  DxStateStoring,
} from "devextreme-vue/data-grid";
import BackButton from "../../components/shared/backButton";
import notify from "devextreme/ui/notify";
import { DxLoadIndicator } from "devextreme-vue/load-indicator";
import { dateWithoutTime } from "../shared/dateHelpers";

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxHeaderFilter,
    DxEditing,
    DxPaging,
    DxFilterRow,
    DxSearchPanel,
    DxButton,
    BackButton,
    DxRequiredRule,
    DxStateStoring,
    DxLoadIndicator,
  },
  data() {
    return {
      organizationVacations: [],
      loadIndicatorVisible: false,
    };
  },
  created() {},
  computed: {
    organizationId() {
      return this.$store.getters.getSelectedOrganizationId;
    },
  },
  watch: {
    organizationId: async function (newValue, oldValue) {
      this.getOrganizationVacations();
    },
  },
  methods: {
    onRowValidating(e) {
      var rowData = Object.assign(e.oldData, e.newData);
      if (rowData.FromDate != undefined && rowData.ToDate != undefined) {
        if (rowData.FromDate > rowData.ToDate) {
          e.isValid = false;
          notify(
            "Η Από ημερομηνία πρέπει να είναι μικρότερη από την Εως",
            "warning",
            3000
          );
          this.getOrganizationVacations();
        }
      }
    },
    onInitNewRow(e) {
      e.data.OrganizationId = this.organizationId;
    },

    async getOrganizationVacations() {
      const res = await mainService.get(
        `/organizationvacations/GetOrganizationVacations?organizationId=${this.organizationId}`
      );
      this.organizationVacations = res.data;
    },
    async onRowInserting(e) {
      //fix strange behaviour of devexpress datepicker
      if (e.data.FromDate != null)
        e.data.FromDate = dateWithoutTime(e.data.FromDate);

      if (e.data.ToDate != null) e.data.ToDate = dateWithoutTime(e.data.ToDate);

      var organizationVacation = e.data;

      try {
        const res = await mainService.post(
          "/organizationvacations/AddOrganizationVacation",
          organizationVacation
        );
        if (res.status != 200) {
          e.cancel = true;
        }

        if (res.data.Id != 0) {
          notify("Η αποθήκευση πέτυχε", "success", 1000);
        } else {
          notify(
            "Υπάρχει Αδράνεια Φορέα με αυτές τις ημερομηνίες",
            "warning",
            5000
          );
        }
        this.getOrganizationVacations();
      } catch (error) {
        e.cancel = true;
      }
    },
    async onRowUpdating(e) {
      //fix strange behaviour of devexpress datepicker
      if (e.newData.FromDate != null)
        e.newData.FromDate = dateWithoutTime(e.newData.FromDate);

      if (e.newData.ToDate != null)
        e.newData.ToDate = dateWithoutTime(e.newData.ToDate);

      var organizationVacation = Object.assign(e.oldData, e.newData);
      organizationVacation.Id = e.key;

      try {
        const res = await mainService.post(
          "/organizationvacations/UpdateOrganizationVacation",
          organizationVacation
        );
        if (res.status != 200) {
          e.cancel = true;
        }

        if (res.data.Id != 0) {
          notify("Η αποθήκευση πέτυχε", "success", 2000);
        } else {
          notify(
            "Υπάρχει Αδράνεια Φορέα με αυτές τις ημερομηνίες",
            "warning",
            5000
          );
        }
        this.getOrganizationVacations();
      } catch (error) {
        e.cancel = true;
      }
    },
    async onRowRemoving(e) {
      var _res = await mainService.delete(
        `/organizationvacations/DeleteOrganizationVacation?id=${e.data.Id}`
      );
      if (_res.data != true) {
        notify("Πρόβλημα κατά την Διαγραφή", "error", 2000);
      }

      notify("Η εγγραφή διαράφηκε επιτυχώς!", "success", 2000);
      this.getOrganizationVacations();
    },
  },
  async mounted() {
    await this.getOrganizationVacations();
  },
};
</script>